<template>
  <w-icon-wrapper
    icon-name="work-universal-storage-icon"
    :height="23.75"
    :width="22"
    view-box="0 0 22 23.75"
  >
    <g
      id="_73_Universeller_Lagerplatz"
      data-name="73 Universeller_Lagerplatz"
      transform="translate(-1 -0.125)"
    >
      <path
        id="Pfad_55797"
        data-name="Pfad 55797"
        d="M21,.125V18H3V.125H1v23.75H3V20H21v3.875h2V.125Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55798"
        data-name="Pfad 55798"
        d="M18.965,17V13.21H5.035V17h1.93V15.21h4.02V17h1.93V15.21h4.12V17Z"
        fill="currentColor"
      />
      <rect
        id="Rechteck_4040"
        data-name="Rechteck 4040"
        width="6"
        height="6"
        transform="translate(11.5 5.882)"
        fill="currentColor"
      />
      <rect
        id="Rechteck_4041"
        data-name="Rechteck 4041"
        width="3.765"
        height="3.765"
        transform="translate(6.5 8.117)"
        fill="currentColor"
      />
      <rect
        id="Rechteck_4042"
        data-name="Rechteck 4042"
        width="2.006"
        height="2.006"
        transform="translate(8.258 4.783)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconUniversalStorage' };
</script>
